// Danh sách scope hợp lệ — không có API list scope riêng, phải khớp
// OpenIddictSeedConstants.SupportedScopeNames bên identity-service .
export const AVAILABLE_SCOPES = [
  'openid',
  'profile',
  'email',
  'roles',
  'offline_access',
  'organization_claims',
  'api',
]
